var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-17
 * @brief EHP Login 화면 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAsync } from "react-async";
import { useRecoilValue, useRecoilState, useSetRecoilState, } from "recoil";
import $ from "jquery";
import "/static/css/login.css";
// recoil
import { langState, getApiLangState } from "../../recoil/langState";
import { userInfoState, authState } from "../../recoil/userState";
import { urlState } from "../../recoil/menuState";
// utils
import { useTrans } from "../../utils/langs/useTrans";
import * as i18n from "../../utils/langs/i18nUtils";
import * as HttpUtil from "../../utils/api/HttpUtil";
import clog from "../../utils/logUtils";
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import * as USERUTILS from "../../utils/user/userUtils";
//
import FindId from "./FindId";
import FindPw from "./FindPw";
import Join from "./join/Join";
import JoinDone from "./join/JoinDone";
function Login() {
    // trans, navigate, ref
    const navigate = useNavigate();
    const t = useTrans();
    // use recoil
    //const setRecoilLangs = useSetRecoilState(langState); // recoil langState
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const apiLang = useRecoilValue(getApiLangState);
    //---------------------------
    const [userInfo, setRecoilUserInfo] = useRecoilState(userInfoState); // recoil userState
    //
    const isAuth = useRecoilValue(authState);
    //
    const setRecoilUrl = useSetRecoilState(urlState);
    //
    const [userId, setUserId] = useState(""); //test@test.com
    const [userPw, setUserPw] = useState(""); //1234qwer!@
    const [resErrorCode, setResErrorCode] = useState(200);
    const [resErrorMsg, setResErrorMsg] = useState("");
    //
    const layerList = ["findId", "findPw"];
    const layerListJoin = ["join-ok", "join-terms"];
    //소설 회원가입
    const [snsId, setSnsId] = useState("");
    const [snsName, setSnsName] = useState("");
    const [snsPhone, setSnsPhone] = useState("");
    const [socialType, setSocialType] = useState("");
    //
    const [certification, setCertification] = useState("");
    // 로그인 유지
    // 초기 로그인 유지 여부를 "Y"로 셋팅
    localStorage.setItem(CONST.STR_KEEP_LOGIN_YN, "Y");
    const [keepLoginYn, setKeepLoginYn] = useState((localStorage.getItem(CONST.STR_KEEP_LOGIN_YN) == null) ? "N" : localStorage.getItem(CONST.STR_KEEP_LOGIN_YN));
    // useAsync call axios  
    //clog("IN LOGIN : LANG SETTING : " + apiLang);
    //20220824 추가
    const [errorList, setErrorList] = useState([]);
    const { data: data, error, isLoading, reload, run: runLogin, } = useAsync({
        //promiseFn: HttpUtil.getUsers,
        deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/api/v2/auth/login",
        appQuery: {
            userId: userId,
            password: userPw,
            language: apiLang
        },
    });
    useEffect(() => {
        let errL = "";
        if (data) {
            //clog("IN LOGIN : USERINFO : " + JSON.stringify(data.body));
            if (data.codeNum == 200) {
                //
                //USERUTILS.getDetailUserInfo(data.body);
                //////////////////////////////////////sessionStorage
                sessionStorage.setItem(CONST.STR_TOKEN, data.body.token);
                sessionStorage.setItem(CONST.STR_TOKEN_EXPIRETIME, data.body.tokenExpireTime);
                /////////////////////////////////////localStorage
                localStorage.setItem(CONST.STR_USERID, userId);
                localStorage.setItem(CONST.STR_USERROLE, data.body.role);
                localStorage.setItem(CONST.STR_REFRESHTOKEN, data.body.refreshToken);
                localStorage.setItem(CONST.STR_REFRESHTOKEN_EXPIRETIME, data.body.refreshTokenExprieTime);
                (() => __awaiter(this, void 0, void 0, function* () {
                    const detailUserInfo = yield USERUTILS.getDetailUserInfoR(data.body);
                    const lang = CUTIL.frontLangSet(detailUserInfo.language);
                    yield i18n.changeLang(lang);
                    //
                    setRecoilLangs(lang);
                    //
                    setRecoilUserInfo({
                        loginTime: detailUserInfo.loginTime,
                        userId: detailUserInfo.userId,
                        email: detailUserInfo.email,
                        userName: detailUserInfo.userName,
                        phoneNumber: detailUserInfo.phoneNumber,
                        companyName: detailUserInfo.companyName,
                        zoneName: detailUserInfo.zoneName,
                        department: detailUserInfo.department,
                        role: detailUserInfo.role,
                        language: detailUserInfo.language,
                        classificationCode: detailUserInfo.classificationCode,
                        classification: detailUserInfo.classification,
                        //socialDtoOut: detailUserInfo.socialDtoOut,
                        agreeMailReceipt: detailUserInfo.agreeMailReceipt,
                        agreeTos: detailUserInfo.agreeTos,
                        agreePersonalInfo: detailUserInfo.agreePersonalInfo,
                        agreeData: detailUserInfo.agreeData,
                        loginInfo: data.body,
                    });
                }))();
                //20220920 수정
            }
            else if (data.codeNum == 999) {
                setResErrorCode(data.codeNum);
                //errL = "Connection error!!!";
                //setResErrorMsg(errL + "-" + resErrorCode);
                setErrorList(data.errorList);
                data.errorList.map((el) => {
                    //errL = errL + el.msg;
                    errL = el.msg;
                });
                setResErrorMsg(errL);
            }
            else {
                setResErrorCode(data.codeNum);
                setErrorList(data.errorList);
                data.errorList.map((el) => {
                    //errL = errL + el.msg;
                    errL = el.msg;
                });
                //setResErrorMsg(errL + "-" + resErrorCode);
                setResErrorMsg(errL);
                // 메일 인증
                if (data.data.errorList[0].msg == "인증되지 않았습니다." && data.data.errorList[0].field == "userId") {
                    var logCertification = document.getElementById("join-oks");
                    if (!CUTIL.isnull(logCertification))
                        logCertification.click();
                }
            }
        }
        // });
    }, [data]);
    //if (isLoading) return <div>로딩중..</div>;
    if (error) {
        // 에러가 안잡힌다.
        {
            clog("IN LOGIN : ERR : " + error.name);
        }
        {
            clog("IN LOGIN : ERR : " + error.stack);
        }
        {
            clog("IN LOGIN : ERR : " + JSON.stringify(error));
        }
    }
    useEffect(() => {
        if (isAuth) {
            const userRole = localStorage.getItem(CONST.STR_USERROLE);
            clog("IN LOGIN : MOVE TO URL : " + userRole);
            if ((userRole) && (userRole === CONST.USERROLE_NONE)) {
                setRecoilUrl(CONST.URL_LANDING);
            }
            else {
                setRecoilUrl(CONST.URL_DASHBOARD);
            }
            navigate("/");
        }
    }, []);
    useEffect(() => {
        setCertification(userId);
    }, [userId]);
    // 다국어 설정 변경 및 recoil 상태 변경
    function exchgLanguage(e, lang) {
        return __awaiter(this, void 0, void 0, function* () {
            // $(".navbar__menu li.active ul li").removeClass("active");
            $(".select-lang button.btn.btn-txt").removeClass("on");
            var tmpTag = (e.target.tagName == "BUTTON") ? e.target : e.currentTarget;
            clog("login comp : exchange : " + tmpTag.tagName);
            tmpTag.className = "btn btn-txt on";
            yield i18n.changeLang(lang);
            setRecoilLangs(lang);
        });
    }
    function layerClose(tagId) {
        var othLayer = tagId;
        //닫기 버튼 , 배경 클릭 시
        $("#" + othLayer)
            .children()
            .children(".js-close")
            .trigger("click", function (ee) {
            $("#" + othLayer).addClass("hidden"); //모든 팝업 감추기
            $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
        });
        //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
        $("#" + othLayer + ".layer-out")
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $(".dimm").stop().hide().css("z-index", "11");
        });
    }
    function layerOpen(e) {
        e.preventDefault();
        var actTag = (e.target.tagName == "BUTTON") ? e.target : e.currentTarget;
        var activeLayer = actTag.getAttribute("data-pop");
        //var activeLayer = $(this).attr("data-pop");
        // close other layer
        layerList.map((olayer) => {
            layerClose(olayer);
        });
        // 레이어 팝업 화면 가운데 정렬
        $("#" + activeLayer + ".popup-layer").css("position", "absolute");
        $("#" + activeLayer + ".popup-layer").css("top", ($(window).height() - $("#" + activeLayer).outerHeight()) / 2 + $(window).scrollTop() + "px");
        $("#" + activeLayer + ".popup-layer").css("left", ($(window).width() - $("#" + activeLayer).outerWidth()) / 2 + $(window).scrollLeft() + "px");
        // $(".popup-layer").addClass("hidden"); //모든 팝업 감추기(팝업안에 팝업이 또 있을때는 해당 안됨)
        $("#" + activeLayer).removeClass("hidden"); //호출한 팝업만 부르기
        $(".dimm").stop().show().css("z-index", "30"); //배경 가져오기
        $("body").css("overflow-y", "hidden"); //body 스크롤 숨기기(화면고정)
        var mql2 = window.matchMedia("screen and (min-width: 501px)");
        if (mql2.matches) {
            $("body").css("overflow-y", "hidden"); //501이상에서 배경고정
        }
        else {
            $("body").css("overflow-y", "auto"); //501이하에서 배경 스크롤
        }
        //닫기 버튼 , 배경 클릭 시
        $("#" + activeLayer)
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $("#" + activeLayer).addClass("hidden"); //모든 팝업 감추기
            $("body").css("overflow-y", "auto"); //body 스크롤 자동 원복
        });
        //제일 바깥쪽 팝업을 닫았을때만 배경 감추기 (팝업안에 팝업이 또 있는 경우는 배경 살림)
        $("#" + activeLayer + ".layer-out")
            .children()
            .children(".js-close")
            .on("click", function (ee) {
            $(".dimm").stop().hide().css("z-index", "11");
        });
    }
    function loginSetting(e) {
        //e.preventDefault();
        clog("CLICK : " + e.target.tagName);
        clog("CLICK : " + e.target.checked);
        setKeepLoginYn((e.target.checked) ? "Y" : "N");
        localStorage.setItem(CONST.STR_KEEP_LOGIN_YN, (e.target.checked) ? "Y" : "N");
    }
    //20220824 추가
    function handleSetUserId(val) {
        //20220922 jhpark 수정
        if ((errorList.filter(err => (err.field === "cntError")).length)) {
            setErrorList(errorList.filter((err) => (err.field !== "cntError")));
            setUserId(val);
        }
        else {
            setErrorList(errorList.filter((err) => (err.field !== "userId")));
            setUserId(val);
        }
    }
    //20220824 추가
    function handleSetUserPw(val) {
        //20220922 jhpark 수정
        if ((errorList.filter(err => (err.field === "cntError")).length)) {
            setErrorList(errorList.filter((err) => (err.field !== "cntError")));
            setUserPw(val);
        }
        else {
            setErrorList(errorList.filter((err) => (err.field !== "password")));
            setUserPw(val);
        }
    }
    function onClickLogin(e) {
        //clog("login click.....");
        runLogin();
    }
    function handleOnKeyPress(e, type) {
        clog("login click.....");
        if (e.key === 'Enter') { // Enter 입력이 되면 클릭 이벤트 실행
            if (type === "INPUT_PASSWORD") {
                onClickLogin(e);
            }
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "login" },
            React.createElement("div", { className: "login__left" },
                React.createElement("div", { className: "left__top" },
                    React.createElement("span", { className: "hide" }, "LS")),
                React.createElement("div", { className: "left__center" },
                    React.createElement("p", null, "Welcome to LS ELECTRIC"),
                    React.createElement("h1", null,
                        React.createElement("img", { src: require("/static/img/logo_login_title.png"), alt: "e-Health Portal" }))),
                React.createElement("p", { className: "left__bottom" }, "LS ELECTRIC \u00A9")),
            React.createElement("div", { className: "login__right" },
                React.createElement("h2", null,
                    React.createElement("p", null,
                        React.createElement("span", null, "Welcome to LS ELECTRIC"),
                        React.createElement("span", null,
                            React.createElement("img", { src: require("/static/img/logo_login_title_color.png"), alt: "e-Health Portal" }))),
                    React.createElement("p", null, t("MESSAGE.로그인해주십시오"))),
                React.createElement("div", { className: "login__form" },
                    React.createElement("form", { action: "#", method: "", name: "loginform" },
                        React.createElement("fieldset", null,
                            React.createElement("legend", null, "\uB85C\uADF8\uC778 \uC815\uBCF4 \uC785\uB825"),
                            React.createElement("ul", { className: "form__input" },
                                React.createElement("li", null,
                                    React.createElement("label", { htmlFor: "userId", className: "hide" }, "\uC544\uC774\uB514 \uC785\uB825"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "text", id: "userId", placeholder: "\uC544\uC774\uB514", 
                                            /* className={((resErrorCode == 200) && (userId.length >= 0)) || ((resErrorCode != 200) && (userId.length > 0)) ? "" : "input-error"} */
                                            /* 20220922추가 jhpark */
                                            className: ((errorList.filter(err => (err.field === "cntError")).length > 0) ||
                                                (errorList.filter(err => (err.field === "userId")).length > 0)) ? "input-error" : "", value: userId, onChange: (e) => handleSetUserId(e.target.value) }))),
                                React.createElement("li", null,
                                    React.createElement("label", { htmlFor: "userPw", className: "hide" }, "\uBE44\uBC00\uBC88\uD638 \uC785\uB825"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "password", id: "userPw", placeholder: "\uBE44\uBC00\uBC88\uD638", 
                                            //className={(resErrorCode == 200) ? "" : "input-error"}
                                            /*  20220922추가 jhpark  */
                                            className: ((errorList.filter(err => (err.field === "cntError")).length > 0) ||
                                                (errorList.filter(err => (err.field === "password")).length > 0) ||
                                                (errorList.filter(err => (err.field === "userId")).length > 0)) ? "input-error" : "", value: userPw, onChange: (e) => handleSetUserPw(e.target.value), onKeyDown: (e) => handleOnKeyPress(e, "INPUT_PASSWORD") }),
                                        React.createElement("p", { className: "input-errortxt" }, ((errorList.filter(err => (err.field === "password")).map((err) => err.msg)).length > 0) ?
                                            (errorList.filter(err => (err.field === "password")).map((err) => err.msg)) :
                                            (errorList.filter(err => (err.field === "cntError")).length > 0) ?
                                                (errorList.filter(err => (err.field === "cntError")).map((err) => err.msg)) :
                                                (errorList.filter(err => (err.field === "userId")).map((err) => err.msg)))))),
                            React.createElement("ul", { className: "form__etc" },
                                React.createElement("li", null,
                                    React.createElement("input", { type: "checkbox", id: "idsave", name: "chksave", 
                                        // onChange={(e) => loginSetting(e)}
                                        checked: (keepLoginYn == "Y") ? true : false, readOnly: true }),
                                    React.createElement("label", { htmlFor: "idsave", className: "hide" }, "\uB85C\uADF8\uC778 \uC720\uC9C0")),
                                React.createElement("li", null,
                                    React.createElement("button", { type: "button", className: "btn btn-txt js-open", "data-pop": "findId", onClick: (e) => layerOpen(e) },
                                        React.createElement("span", null, t("LABEL.아이디찾기"))),
                                    React.createElement("button", { type: "button", className: "btn btn-txt js-open", "data-pop": "findPw", onClick: (e) => layerOpen(e) },
                                        React.createElement("span", null, t("LABEL.비밀번호찾기"))))),
                            React.createElement("button", { type: "button", className: "btn-login", onClick: (e) => onClickLogin(e) },
                                React.createElement("span", null, "\uB85C\uADF8\uC778"))))),
                React.createElement("ul", { className: "join" },
                    React.createElement("li", null,
                        React.createElement("p", null, "\uC544\uC9C1 \uD68C\uC6D0\uC774 \uC544\uB2C8\uC2E0\uAC00\uC694?"),
                        React.createElement("button", { type: "button", id: "join-oks", className: "btn btn-txt hide js-open", "data-pop": "join-ok", onClick: layerOpen },
                            React.createElement("span", null, "\uD68C\uC6D0\uAC00\uC785")),
                        React.createElement("button", { type: "button", className: "btn btn-txt js-open", "data-pop": "join", onClick: layerOpen },
                            React.createElement("span", null, "\uD68C\uC6D0\uAC00\uC785"))),
                    React.createElement("li", { className: "join__sns" })),
                React.createElement("div", { className: "select-lang" },
                    React.createElement("button", { type: "button", className: `btn btn-txt ${(langs == CONST.STR_LANG_KOR) ? "on" : ""}`, onClick: (e) => (langs !== CONST.STR_LANG_KOR) && exchgLanguage(e, CONST.STR_LANG_KOR) },
                        React.createElement("span", null, "\uD55C\uAD6D\uC5B4")),
                    " ",
                    React.createElement("button", { type: "button", className: `btn btn-txt ${(langs == CONST.STR_LANG_ENG) ? "on" : ""}`, onClick: (e) => (langs !== CONST.STR_LANG_ENG) && exchgLanguage(e, CONST.STR_LANG_ENG) },
                        React.createElement("span", null, "English")),
                    React.createElement("button", { type: "button", className: `btn btn-txt ${(langs == CONST.STR_LANG_CHA) ? "on" : ""}`, onClick: (e) => (langs !== CONST.STR_LANG_CHA) && exchgLanguage(e, CONST.STR_LANG_CHA) },
                        React.createElement("span", null, "\u4E2D\u6587"))))),
        React.createElement(Join, { layerList: layerListJoin, isRunYn: false, setCertification: setCertification }),
        (certification) &&
            React.createElement(JoinDone, { certification: certification }),
        React.createElement(FindId, { layerList: layerList, isRunYn: false }),
        React.createElement(FindPw, { layerList: layerList, isRunYn: false }),
        React.createElement("div", { className: "dimm" }),
        " "));
}
export default Login;
function LoginIdInputArea(props) {
    const errCode = props.errCode;
    const userId = props.userId;
    const setUserId = props.handleFunc;
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "text", id: "userId", placeholder: "\uC544\uC774\uB514", className: (errCode == 200) ? "" : "input-error", value: userId, onChange: (e) => setUserId(e.target.value) })));
}
function LoginPwInputArea(props) {
    const errCode = props.errCode;
    const errList = props.errList;
    const userPw = props.userPw;
    const setUserPw = props.handleFunc;
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "password", id: "userPw", placeholder: "\uBE44\uBC00\uBC88\uD638", className: errCode == 200 ? "" : "input-error", value: userPw, onChange: (e) => setUserPw(e.target.value) }),
        (errCode === 200) ? ("") : (React.createElement("p", { className: "input-errortxt" }, errList))));
}
